import PropTypes from 'prop-types';
import React from 'react';

import { ButtonFilled, Image } from 'Components/Base';

const ClearButton = ({ onClick, ...restProps }) => {
  return (
    <ButtonFilled
      onClick={onClick}
      px={{ _: 4, md: 5 }}
      pb={1}
      pt={2}
      color={'white'}
      height={'40px'}
      {...restProps}
    >
      <Image
        width={'60px'}
        mx={'auto'}
        srcSet={
          '/assets/images/classroom/clearButton-1x.png 1x, /assets/images/classroom/clearButton-2x.png 2x, /assets/images/classroom/clearButton-3x.png 3x,'
        }
        src={'/assets/images/classroom/clearButton-3x.png'}
      />
    </ButtonFilled>
  );
};

ClearButton.propTypes = {
  onClick: PropTypes.func,
};

ClearButton.defaultProps = {
  onClick: () => {},
};

export default ClearButton;
